export const RCDSInitialState = {
  status: "pending", // pending, loading, success, error
  error: null,
  childData: null,
  childNotFoundList: [],
  lookupError: ""
};

export default RCDSInitialState;
